import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';

/**
 * O modelo de coleta da empresa (Agendamento / OS / Ficha clinica) e os
 * campos de cada um, como a API descreve (modules/registros/modelos.js).
 *
 * As telas nao conhecem nenhum campo pelo nome: formulario, lista e menu saem
 * daqui. Um campo novo no servidor aparece sozinho em todas elas.
 *
 * `ativo: false`: nao busca (o login de profissional nao tem acesso a esta rota).
 */
export function useModelosColeta({ ativo = true } = {}) {
  return useQuery({
    enabled: ativo,
    queryKey: ['registros', 'modelos'],
    queryFn: () => api.get('/api/registros/modelos'),
    staleTime: 60_000
  });
}

/** O modelo ativo SE ele tiver registro (OS / ficha); `null` no agendamento puro. */
export function modeloComRegistro(dados) {
  const m = dados?.modelos?.find((x) => x.chave === dados.ativo);
  return m && m.campos.length ? m : null;
}

export const ROTULO_STATUS_REGISTRO = {
  coletando: 'Coletando dados',
  pronta: 'Pronta',
  em_andamento: 'Em andamento',
  concluida: 'Concluída',
  cancelada: 'Cancelada'
};

export const TOM_STATUS_REGISTRO = {
  coletando: 'alerta',
  pronta: 'info',
  em_andamento: 'primario',
  concluida: 'sucesso',
  cancelada: 'neutro'
};

/** Como um valor gravado aparece na lista e no detalhe. */
export function valorLegivel(campo, valor) {
  if (valor === undefined || valor === null || valor === '') return '';
  if (campo.tipo === 'sim_nao') return valor ? 'Sim' : 'Não';
  if (campo.tipo === 'data' && /^\d{4}-\d{2}-\d{2}$/.test(String(valor))) return String(valor).split('-').reverse().join('/');
  return String(valor);
}
